import * as React from "react";
const EndToEndSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={56}
    height={56}
    fill="none"
    {...props}
  >
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      fill="#EF4136"
      fillOpacity={0.02}
      rx={24}
    />
    <rect
      width={48}
      height={48}
      x={4}
      y={4}
      stroke="#EF4136"
      strokeOpacity={0.04}
      strokeWidth={8}
      rx={24}
    />
    <path
      fill="#EF4136"
      d="M35.875 32.375A3.506 3.506 0 0 0 32.485 35h-10.61a3.5 3.5 0 1 1 0-7h10.5a4.375 4.375 0 1 0 0-8.75h-10.5a.875.875 0 1 0 0 1.75h10.5a2.625 2.625 0 0 1 0 5.25h-10.5a5.25 5.25 0 1 0 0 10.5h10.61a3.5 3.5 0 1 0 3.39-4.375Zm0 5.25a1.75 1.75 0 1 1 0-3.5 1.75 1.75 0 0 1 0 3.5Z"
    />
  </svg>
);
export default EndToEndSVG;
